import axios from 'axios';

const getPermissionList = async (apiEndpoint: string, authToken: string) => {
  const PERMISSION_URL = `https://${apiEndpoint}/permissions-proxy/permissions/list`;

  try {
    const response = await axios.get(PERMISSION_URL, {
      headers: {
        authorization: `Bearer ${authToken}`,
      },
    });

    return response.data;
  } catch (e) {
    if (e instanceof Error) {
      // eslint-disable-next-line no-console
      console.log(`Failed to load permission list: ${e.message}`);
    } else {
      // eslint-disable-next-line no-console
      console.log(`Unknown Error: ${e}`);
    }
    return null;
  }
};

export default getPermissionList;
